// Admin email allowlist — single source of truth.
//
// Used by:
//   - App.jsx — routes admin emails to AdminApp by default
//   - PortalSwitcher.jsx — surfaces "Switch to Admin" in the dropdown
//   - DemoBanner (indirectly — DEMO_EMAILS lives there but stays separate)
//
// TODO: replace with a profiles.is_admin boolean once there's more than
// one admin. Case-insensitive — Supabase stores auth emails lowercase.

export const ADMIN_EMAILS = new Set(['basem.aboulhosn@gmail.com']);

export function isAdminEmail(email) {
  return Boolean(email) && ADMIN_EMAILS.has(email.toLowerCase());
}
